/* =========================================================================
   Skuggarkivet - all interaktivitet pa ett stalle.
   - AJAX "lagg i kundvagn" + varukorgslada
   - Fri frakt-matare
   - Antal +/- och ta bort (bade i ladan och pa /cart)
   - Klistrad kopruta pa mobil
   - Produktgalleri och mobilmeny
   ========================================================================= */
(function () {
  "use strict";

  var CFG = window.SKConfig || {};
  var T = CFG.i18n || {};
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

  var ICON = {
    minus: "<svg width='15' height='15' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.6' stroke-linecap='round' aria-hidden='true'><path d='M5 12h14'/></svg>",
    plus: "<svg width='15' height='15' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.6' stroke-linecap='round' aria-hidden='true'><path d='M12 5v14M5 12h14'/></svg>"
  };

  function q(s, r) { return (r || document).querySelector(s); }
  function qa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function up(el, sel) { return el && el.closest ? el.closest(sel) : null; }

  function esc(v) {
    return String(v == null ? "" : v).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function sized(url, w) {
    if (!url) return "";
    return url + (url.indexOf("?") > -1 ? "&" : "?") + "width=" + w;
  }

  /* ---- Prisformat (foljer butikens money_format) ----------------------- */
  function group(cents, decimals, thousands, decimalSep) {
    var parts = (cents / 100).toFixed(decimals).split(".");
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts[1] ? whole + decimalSep + parts[1] : whole;
  }

  function money(cents) {
    var fmt = CFG.moneyFormat || "{{amount_no_decimals}} kr";
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, key) {
      switch (key) {
        case "amount": return group(cents, 2, ",", ".");
        case "amount_no_decimals": return group(cents, 0, ",", ".");
        case "amount_with_comma_separator": return group(cents, 2, ".", ",");
        case "amount_no_decimals_with_comma_separator": return group(cents, 0, ".", ",");
        case "amount_with_space_separator": return group(cents, 2, " ", ",");
        case "amount_no_decimals_with_space_separator": return group(cents, 0, " ", ",");
        default: return group(cents, 0, " ", ",");
      }
    });
  }

  /* ---- Liten avisering ------------------------------------------------- */
  var toastEl;
  function toast(msg) {
    if (!msg) return;
    if (!toastEl) {
      toastEl = document.createElement("div");
      toastEl.className = "sk-toast";
      toastEl.setAttribute("role", "status");
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add("is-visible");
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove("is-visible"); }, 2600);
  }

  /* ---- Varukorgslada --------------------------------------------------- */
  var drawer = q("[data-sk-drawer]");
  var lastFocused = null;

  function openDrawer() {
    if (!drawer) return;
    lastFocused = document.activeElement;
    drawer.hidden = false;
    void drawer.offsetWidth;
    drawer.classList.add("is-open");
    document.body.classList.add("sk-no-scroll");
    var c = q(".sk-drawer__close", drawer);
    if (c) c.focus();
  }

  function closeDrawer() {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove("is-open");
    document.body.classList.remove("sk-no-scroll");
    setTimeout(function () { drawer.hidden = true; }, 280);
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  /* ---- Fri frakt-matare ------------------------------------------------ */
  function shipBar(total) {
    var bar = q("[data-sk-ship]");
    if (!bar) return;
    var goal = Number(CFG.shipGoal || 0);
    if (!goal || !total) { bar.hidden = true; return; }
    bar.hidden = false;
    var left = goal - total;
    var pct = Math.max(0, Math.min(100, (total / goal) * 100));
    var txt = q("[data-sk-ship-text]", bar);
    if (left > 0) {
      bar.classList.remove("is-unlocked");
      txt.innerHTML = String(T.remaining || "").replace("{amount}", "<b>" + money(left) + "</b>");
    } else {
      bar.classList.add("is-unlocked");
      txt.textContent = T.unlocked || "";
    }
    q("[data-sk-ship-fill]", bar).style.width = pct + "%";
  }
  /* ---- Rendering av rader ---------------------------------------------- */
  function lineHtml(item, index) {
    var hasVariant = item.variant_title && item.variant_title !== "Default Title";
    var meta = hasVariant ? esc(item.variant_title) : money(item.final_price) + " / st";
    return '<li class="sk-line" data-sk-line="' + (index + 1) + '">' +
      '<a href="' + esc(item.url) + '" tabindex="-1" aria-hidden="true">' +
        '<img class="sk-line__img" src="' + esc(sized(item.image, 160)) + '" alt="" width="64" height="96" loading="lazy">' +
      '</a>' +
      '<div>' +
        '<h3 class="sk-line__title"><a href="' + esc(item.url) + '">' + esc(item.product_title) + '</a></h3>' +
        '<p class="sk-line__meta">' + meta + '</p>' +
        '<div class="sk-line__bottom">' +
          '<div class="sk-qty">' +
            '<button type="button" data-sk-qty="-1" aria-label="' + esc(T.minus) + '">' + ICON.minus + '</button>' +
            '<span class="sk-qty__val">' + item.quantity + '</span>' +
            '<button type="button" data-sk-qty="1" aria-label="' + esc(T.plus) + '">' + ICON.plus + '</button>' +
          '</div>' +
          '<span class="sk-line__price">' + money(item.final_line_price) + '</span>' +
        '</div>' +
        '<button type="button" class="sk-line__remove" data-sk-qty="0">' + esc(T.remove) + '</button>' +
      '</div>' +
    '</li>';
  }

  function render(cart) {
    qa("[data-sk-cart-count]").forEach(function (el) { el.textContent = cart.item_count; });
    qa("[data-sk-lines]").forEach(function (list) { list.innerHTML = cart.items.map(lineHtml).join(""); });
    qa("[data-sk-empty]").forEach(function (el) { el.hidden = cart.item_count > 0; });
    qa("[data-sk-foot]").forEach(function (el) { el.hidden = cart.item_count === 0; });
    qa("[data-sk-total]").forEach(function (el) { el.innerHTML = money(cart.total_price); });
    shipBar(cart.total_price);
  }

  function refresh() {
    return fetch(ROOT + "cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); return cart; });
  }

  function change(line, quantity) {
    return fetch(ROOT + "cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); return cart; })
      .catch(function () { toast(T.error); });
  }

  /* ---- Handelser ------------------------------------------------------- */
  document.addEventListener("click", function (e) {
    var t = e.target;

    if (up(t, "[data-sk-close]")) { e.preventDefault(); closeDrawer(); return; }

    if (up(t, "[data-sk-open-cart]") && drawer) {
      e.preventDefault();
      refresh().then(openDrawer);
      return;
    }

    var qtyBtn = up(t, "[data-sk-qty]");
    if (qtyBtn) {
      var row = up(qtyBtn, "[data-sk-line]");
      if (row) {
        e.preventDefault();
        var line = parseInt(row.getAttribute("data-sk-line"), 10);
        var delta = parseInt(qtyBtn.getAttribute("data-sk-qty"), 10);
        var valEl = q(".sk-qty__val", row);
        var current = valEl ? parseInt(valEl.textContent, 10) : 1;
        change(line, delta === 0 ? 0 : Math.max(0, current + delta));
      }
      return;
    }

    var thumb = up(t, "[data-sk-thumb]");
    if (thumb) {
      e.preventDefault();
      var main = q("[data-sk-main-image]");
      if (main) {
        main.src = thumb.getAttribute("data-sk-thumb");
        var ss = thumb.getAttribute("data-sk-thumb-srcset");
        if (ss) main.srcset = ss;
        qa("[data-sk-thumb]").forEach(function (el) { el.classList.toggle("is-active", el === thumb); });
      }
      return;
    }

    var burger = up(t, "[data-sk-burger]");
    if (burger) {
      var nav = document.getElementById(burger.getAttribute("aria-controls"));
      if (nav) {
        var open = nav.classList.toggle("is-open");
        burger.setAttribute("aria-expanded", open ? "true" : "false");
      }
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" || e.key === "Esc") closeDrawer();
  });

  /* ---- Lagg i kundvagn utan omladdning --------------------------------- */
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!form || !form.getAttribute) return;
    if ((form.getAttribute("action") || "").indexOf("/cart/add") === -1) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.classList.add("is-busy"); btn.disabled = true; }
    fetch(ROOT + "cart/add.js", {
      method: "POST",
      headers: { Accept: "application/json" },
      body: new FormData(form)
    })
      .then(function (r) { if (!r.ok) throw new Error("add"); return r.json(); })
      .then(function () { return refresh(); })
      .then(function () { openDrawer(); })
      .catch(function () { toast(T.error); })
      .then(function () { if (btn) { btn.classList.remove("is-busy"); btn.disabled = false; } });
  });

  /* ---- Klistrad kopruta pa mobil --------------------------------------- */
  (function () {
    var bar = q("[data-sk-sticky]");
    var anchor = q("[data-sk-atc-anchor]");
    if (!bar || !anchor || !("IntersectionObserver" in window)) return;
    new IntersectionObserver(function (entries) {
      bar.classList.toggle("is-visible", !entries[0].isIntersecting);
    }, { rootMargin: "0px 0px -15% 0px" }).observe(anchor);
  })();
  /* ---- Antalsvaljare pa produktsidan ---------------------------------- */
  document.addEventListener("click", function (e) {
    var step = up(e.target, "[data-sk-step]");
    if (!step) return;
    e.preventDefault();
    var field = step.parentNode.querySelector('input[name="quantity"]');
    if (!field) return;
    field.value = Math.max(1, (parseInt(field.value, 10) || 1) + parseInt(step.getAttribute("data-sk-step"), 10));
  });

  if (drawer) refresh();
})();
